import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["passwordFieldset", "googleFieldset"];

  selectPassword() {
    this.passwordFieldsetTarget.disabled = false;
    this.googleFieldsetTarget.disabled = true;
  }

  selectGoogle() {
    this.passwordFieldsetTarget.disabled = true;
    this.googleFieldsetTarget.disabled = false;
  }
}
